<div class="wrapper bg-area" *ngIf="!isMobile">
  <section id="pagamentos">
    <div class="container area-faca-parte">
      <div class="header-faca-parte columns">
        <div class="column is-6">
          <h3 class="title">Monte seu Plano</h3>
          <div class="bar__container">
            <ul class="bar" id="bar">
              <li class="active active-step"><i class="fas fa-check"></i>Plano</li>
              <li class="active active-step"><i class="fas fa-check"></i>Dados Pessoais</li>
              <li>Confirmação</li>
            </ul>
          </div>
        </div>
      </div>
      <form class="sample-form" method="post" target="_top">
        <div class="body-faca-parte columns">
          <div class="column" *ngIf="propostaResult">
            <iframe #salesFrame class="gateway-pagamento" [src]="iframeSrc | urlPipe" allowfullscreen height="807" width="1164"></iframe>
          </div>
        </div>
      </form>
    </div>
  </section>

</div>
<div class="wrapper bg-area" *ngIf="isMobile">
  <section id="pagamentos-mobile">
    <div class="container area-faca-parte">
      <div class="header-faca-parte columns">
        <div class="column is-6">
          <div class="title">
            <h3>Agora, seus Dados de Pagamento</h3>
          </div>
          <div class="subtitle">
            <h4>ESCOLHA SUA FORMA DE PAGAMENTO</h4>
          </div>
          <form class="sample-form" method="post" target="_top">
              <div class="body-faca-parte columns">
                <div class="column">
                  <iframe
                          #iframe
                          class="gateway-pagamento"
                          [src]="iframeSrc | urlPipe" allowfullscreen
                  ></iframe>
                </div>
              </div>

            </form>

        </div>
      </div>
    </div>
  </section>

</div>
